module.exports = __webpack_public_path__ + "img/souvenirs-02.77e13d0f.png";